"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _customProps = require("../../utils/customProps");

var _customComponents = require("../../utils/customComponents");

var _Storyblok = _interopRequireDefault(require("../../utils/Storyblok"));

var _DropDownMenu = _interopRequireDefault(require("./components/DropDownMenu/DropDownMenu"));

var _MuiMenuItem = _interopRequireDefault(require("./components/MuiMenuItem/MuiMenuItem"));

var MuiMenu = function MuiMenu(_ref) {
  var content = _ref.content,
      rootClass = _ref.rootClass,
      size = _ref.size,
      color = _ref.color,
      btnText = _ref.btnText;

  var styles = _Storyblok.default.arrayToMuiStyles(rootClass);

  return /*#__PURE__*/_react.default.createElement(_DropDownMenu.default, {
    rootClass: styles.root,
    btnTxt: btnText,
    size: size,
    color: color
  }, content.map(function (component, key) {
    return (0, _customComponents.renderComponents)({
      MuiMenuItem: _MuiMenuItem.default
    }, component, key);
  }));
};

var _default = MuiMenu;
exports.default = _default;
MuiMenu.propTypes = {
  /**
   * mui prop: 'small', 'medium', 'large'
   */
  size: function size(props, propName, componentName) {
    var validProps = ['small', 'medium', 'large'];
    return (0, _customProps.muiStringProp)(props, propName, componentName, validProps);
  },

  /**
   * mui prop: 'default', 'inherit', 'primary', 'secondary'
   */
  color: function color(props, propName, componentName) {
    var validProps = ['default', 'inherit', 'primary', 'secondary'];
    return (0, _customProps.muiStringProp)(props, propName, componentName, validProps);
  },

  /** text for the btn */
  btnText: _propTypes.default.string.isRequired,

  /** stroyblok multiselect of css classes */
  rootClass: _propTypes.default.arrayOf(_propTypes.default.string),

  /** MuiMenuItem */
  content: function content(props, propName, componentName) {
    var components = ['MuiMenuItem'];
    return (0, _customProps.validComponents)(props, propName, componentName, components);
  }
};
MuiMenu.defaultProps = {
  rootClass: [],
  size: 'medium',
  color: 'default',
  content: []
};